module.exports = __webpack_public_path__ + "media/images/holon-button-9ff05d81.png";